// --- START EDIT: Neutral, clearer affordance — stronger dashed border; hover/active fills ---
import { useDropzone } from "react-dropzone";
import { UploadCloud } from "lucide-react";
import { useTranslation } from "react-i18next";

interface DropzoneProps {
  onFileAccepted: (file: File) => void;
}

const Dropzone = ({ onFileAccepted }: DropzoneProps) => {
  const { t } = useTranslation('upload');
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        onFileAccepted(acceptedFiles[0]);
      }
    },
    multiple: false,
    accept: {
      "model/stl": [".stl"],
      "model/obj": [".obj"],
      "application/octet-stream": [".stl", ".obj"],
    },
  });

  return (
    <div
      {...getRootProps()}
      className={[
        "rounded-xl p-6 text-center cursor-pointer transition-colors border-2 border-dashed",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        isDragActive
          ? "bg-white/10 border-white/40"
          : "bg-card/70 border-border hover:bg-white/8",
      ].join(" ")}
    >
      <input {...getInputProps()} />
      <UploadCloud
        className={[
          "w-12 h-12 mx-auto mb-2",
          isDragActive ? "text-foreground" : "text-muted-foreground",
        ].join(" ")}
      />
      <p className="text-muted-foreground">
        {isDragActive ? t('dropzone.active') : t('dropzone.idle')}
      </p>
    </div>
  );
};

export default Dropzone;
// --- END EDIT: Neutral, clearer affordance — stronger dashed border; hover/active fills ---